/* eslint-disable react/no-danger */
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import PlainButton from '../buttons/Plain';

import styles from '../../../styles/blocks/button.module.scss';

const propTypes = {
    label: PropTypes.string,
    url: PropTypes.string,
    isContainer: PropTypes.bool,
    className: PropTypes.string,
    containerClassName: PropTypes.string,
};

const defaultProps = {
    label: null,
    url: null,
    isContainer: false,
    className: null,
    containerClassName: null,
};

const Button = ({ label, url, isContainer, className, containerClassName }) => (
    <div
        className={classNames({
            [styles.container]: true,
            [className]: className !== null,
        })}
    >
        <div
            className={classNames([
                styles.inner,
                {
                    [styles.isContainer]: isContainer,
                    [containerClassName]: isContainer && containerClassName !== null,
                },
            ])}
        >
            <PlainButton href={url} external className={styles.button}>
                {label}
            </PlainButton>
        </div>
    </div>
);

Button.propTypes = propTypes;
Button.defaultProps = defaultProps;

export default Button;
